/**
 * Returns convo, link and span elements from the
 * embed snippet
 *
 * @returns {object} elements
 */
export default function getSnippetElements() {
  const convos = document.querySelectorAll("convo");

  if (convos.length > 1) {
    throw new Error("Multiple embeds are not supported");
  }

  const convo = convos[0];
  const link = document.querySelector("convo > a");
  const span = document.querySelector("convo > a > span");

  if (
    !convo ||
    !link ||
    !link.href ||
    !link.href.includes("/experience/") ||
    !span
  ) {
    throw new Error("There is a problem with the embed snippet");
  }

  return {
    convo,
    link,
    span
  };
}
